import React from 'react';
import { Typography } from 'antd';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';

const Stat = ({ title, icon: IconComponent, value, imgUrl, width=200 }) => {
  const backgroundStyle = imgUrl ? `url(${imgUrl})` : '#fff';
  const color = imgUrl ? '#fff' : '#000';

  return (
    <Card sx={{
      textAlign: 'center',
      padding: 0,
      minWidth: 150,
      width: width,
      borderRadius: 1,
      boxShadow: 'none',
      background: backgroundStyle,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <CardContent sx={{
        padding: 0,
        '&:last-child': { paddingBottom: '12px' }, // Apply the override here
      }}>
        <Box display="flex" alignItems="top" sx={{ padding: '8px 20px 0 10px' }}>
          <Box sx={{ textAlign: 'left', padding: 0 }}>
            <Typography.Text style={{ fontFamily: "Roboto, sans-serif", fontSize: '13px', wordBreak: 'break-word', fontWeight: '300', color, textTransform:'uppercase' }}>
              {title}<br/>
              <Typography.Text style={{ display: 'block', fontSize: '22px', color: color }}>
                {value}
              </Typography.Text>
            </Typography.Text>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Stat;
